import { hideDialog, openDialog } from '../../../react/features/base/dialog/actions';
import { WILDIX_METADATA } from '../../constants';
import { WaitForSpeakerDialog } from './components';
import { getUserDataBySystem } from './functions';
export function openWaitForSpeakerDialog(props) {
    return openDialog(WaitForSpeakerDialog, props);
}
export function hideSpeakerDialog() {
    return hideDialog(WaitForSpeakerDialog);
}
export function sendMetaWebinarConfig(conference) {
    return (dispatch, getState) => {
        const state = getState();
        const { staticWebinarData } = getUserDataBySystem(state);
        conference?.getMetadataHandler()?.setMetadata(WILDIX_METADATA, {
            webinarConfig: staticWebinarData
        });
    };
}
